import axios from '../../axios'


// 保存
export const save = (data) => {
    return axios({
        url: '/stusign/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/stusign/delete',
        method: 'post',
        data
    })
}
// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/stusign/list',
        method: 'post',
        data
    })
}
// 明细查询
export const detailView = (data) => {
    return axios({
        url: '/stusign/detail',
        method: 'post',
        data
    })
}
// 手动生成日志
export const createRecord = (data) => {
  return axios({
    url: '/stusign/createRecord',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/stusign/stusign.js